export default __webpack_public_path__ + "static/media/samatur_contrate_o_vexado.2a60b796.webp";